<template>
    <div>
        <Nav></Nav>
        <PageHeader :linkto="'/Overall'" :linkttitle="'返回'" :title="productName"></PageHeader>
        <AnaLoading way="Client" :show="pageloading"></AnaLoading>
        <div v-if="!pageloading">
        <b-container v-if="pageview" class="resultContainer">
            <NameCardOne :data="anaResult.Basic" ></NameCardOne>
            <ResultCard :title="anaResult.Basic.name+'的個性分析'" :listdata="anaResult.Cpersonality.explantion" :resultname="'result'"></ResultCard>
            <YearCard :name="anaResult.Basic.name" :listdata="anaResult.AAllyear"></YearCard>
            <ResultCard title="感情財運事業小叮嚀" :listdata="anaResult.Overall.data.Tips.explantion" :resultname="'result'"></ResultCard>
            <ResultCard title="當日好運分析" :listdata="anaResult.Overall.data.Lucky.explantion" :resultname="'result'"></ResultCard>
            <ResultCard title="當日健康提醒" :listdata="anaResult.Overall.data.Helth.explantion" :resultname="'result'"></ResultCard>
            <ResultCard title="當日幸運小物" :listdata="anaResult.Overall.data.Small.explantion" :resultname="'result'"></ResultCard>
            <ResultCard title="當日穿搭建議" :listdata="anaResult.Overall.data.Cloth.explantion" :resultname="'result'"></ResultCard>

            <MediaBanner></MediaBanner>
        </b-container>
        <b-container v-else>

            <b-button class="mt-3" variant="primary" block to="/Overall">返回{{ productName }}</b-button>
            <b-button class="mt-3" variant="primary" block to="/HistoryLog/4">返回歷史紀錄</b-button>
        </b-container>
        </div>
    </div>
</template>

<script>
import {mapState} from 'vuex'
import Nav from '@/components/Nav.vue'
import PageHeader from '@/components/PageHeader.vue'
import NameCardOne from '@/components/NameCardOne.vue'
// import PlusClothCard from '@/components/PlusClothCard.vue'
import YearCard from '@/components/YearCard.vue'

import PresonalCard from '@/components/PresonalCard.vue'
import ResultCard from '@/components/ResultCard.vue'
import MediaBanner from '@/components/MediaBanner.vue'
import AnaLoading from '@/components/AnaLoading.vue'
import {playSound} from '@/service/commuse'

export default {
  name: 'ClientResult',
  components: {Nav,PageHeader,NameCardOne,ResultCard,MediaBanner,YearCard,AnaLoading},
  data () {
    return {
      productName:'總體運勢',
      pageloading:true,
    }
  },
  computed:{
    ...mapState(['anaResult']),
    pageview:function () {return Object.keys(this.anaResult).length === 0 ? false: true;},
  },
  mounted(){
    this.loadingView()
  },
  methods: {

    loadingView(){
      setTimeout(()=>{
        if(this.pageview){
          playSound()
        }
        this.pageloading = false
      },2500)


    }

  }
}
</script>

<style scoped>

</style>
